import { useCallback, useRef } from "react";
import type { SandboxRenderResult } from "../../../components/UIToolkit/Previews/SandboxedHtmlRenderer";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { renderFailureOf } from "./customPrintoutRepair";

/**
 * Tracks `ai_printout_completeness_failed` (no names) once per template source that fails, so drift in saved
 * templates shows in analytics without counting every redraw of the same one.
 */
export const useCompletenessFailureTracking = (printoutId: string | null) => {
	const { track } = useAnalytics();
	const { chosenDepartment } = useHospitalData();
	const departmentId = chosenDepartment.department_id;
	const trackedSourceRef = useRef<string | null>(null);
	return useCallback(
		(result: SandboxRenderResult, source: string | null) => {
			const failure = renderFailureOf(result);
			if (failure === null || trackedSourceRef.current === source) return;
			trackedSourceRef.current = source;
			track("ai_printout_completeness_failed", {
				department_id: departmentId,
				printout_id: printoutId,
				missing_count: failure.missingShiftIds.length,
				kind: failure.kind,
			});
		},
		[track, departmentId, printoutId],
	);
};
